export default "__VITE_ASSET__BFFmTFmO__"